// lang文件夹下index.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import en from './en' //英文
import zh from './zh' //中文
Vue.use(VueI18n)
 
const messages = {
    zh: {
        language: '简体中文',
        ...zh,
        ...zhLocale
    },
    en: {
        language: 'English',
        ...en,
        ...enLocale
    },
    
}
const i18n = new VueI18n({
    locale: localStorage.getItem('locale') || 'zh', // 语言类型存储到localstorage里
    messages,
    silentTranslationWarn: true
})
// 导出messages 给切换语言的时候用
export { i18n, messages }


// WEBPACK FOOTER //
// ./src/lang/index.js